import React from 'react';
import { StickyDiv } from '../../QnaPage/ConsultNudge/styled';
import NewStrip from './NewStrip';
import { useRouter } from 'next/router';

function OfferStripHeader(props) {
  const {
    offerData,
    pdp,
    sticky,
    showHeader,
    stickyOnly,
    isDiaperSku,
    marqueeTextArray,
    leftPadding,
    isForJoyfulPage,
    redirectionUrl,
    bgColor,
    textColor,
    text,
    showNewUi,
  } = props;
  let params = null;
  if (typeof window != 'undefined') {
    params = new URLSearchParams(window.location.search);
  }
  const router = useRouter();

  const handleClick = () => {
    if (redirectionUrl) {
      router.push(redirectionUrl);
    }
  };

  return (
    <StickyDiv
      showHeader={showHeader}
      onScrollCapture={true}
      pdp={pdp}
      sticky={sticky}
      stickyOnly={stickyOnly}
      showPopup={params?.has('imageGallery')}
      isDiaperSku={isDiaperSku}
      isForJoyfulPage={isForJoyfulPage}
      redirectionUrl={redirectionUrl}
      onClick={handleClick}
    >
      <NewStrip
        offerData={offerData}
        marqueeTextArray={marqueeTextArray}
        leftPadding={leftPadding}
        bgColor={bgColor}
        textColor={textColor}
        text={text}
        showNewUi={showNewUi}
      />
    </StickyDiv>
  );
}

export default OfferStripHeader;
